import { render } from "./Btn_additem.vue?vue&type=template&id=78710981&scoped=true"
import script from "./Btn_additem.vue?vue&type=script&lang=js"
export * from "./Btn_additem.vue?vue&type=script&lang=js"

import "./Btn_additem.vue?vue&type=style&index=0&id=78710981&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78710981"]])

export default __exports__